export default "__VITE_ASSET__CD_iOORd__"